import { RequestMethod, } from '.';
import { AppProxyAPI, } from './AppProxyAPI';
/**
 * This is the class used for making API call to MODE's app proxy server.
 */
export class ModeAppProxyAPI extends AppProxyAPI {
    /**
     * Return an Instance of ModeAppProxyAPI. This is what dev should be using to get an instance of ModeAppProxyAPI
     * and use it to make API call.
     */
    static getInstance() {
        if (!ModeAppProxyAPI.instance) {
            ModeAppProxyAPI.instance = new ModeAppProxyAPI();
        }
        return ModeAppProxyAPI.instance;
    }
    /**
     * Generic function to send a request to the app proxy server
     * @param homeId
     * @param logSourcePath
     * @returns
     */
    async getEventLog(homeId, logSourcePath, filters) {
        const response = await this.sendRequest(RequestMethod.GET, `homes/${homeId}/appProxy${logSourcePath.startsWith('/') ? '' : '/'}${logSourcePath}`, filters);
        return response.data;
    }
    /**
     * Generic function to send a request to the app proxy server
     * @param homeId
     * @param relativePath
     * @returns
     */
    async sendAppProxyRequest(method, homeId, relativePath, data, headers, otherConfigs) {
        const response = await this.sendRequest(method, `homes/${homeId}/appProxy${relativePath.startsWith('/') ? '' : '/'}${relativePath}`, data, headers, otherConfigs);
        return response;
    }
}
